import { JSX } from 'react';
import { Dayjs } from 'dayjs';
import { mapScheduleDateData } from 'entities/schedulePublic/lib';
import { mappedTeacherSchedule } from 'entities/types';
import { mappedGroupSchedule } from 'entities/types';

import { RowTimelineSchedule } from '../../rowTimelineSchedule';

export const MakeRows = (
  data: mappedGroupSchedule | mappedTeacherSchedule,
  startDate: Dayjs,
  endDate: Dayjs,
) => {
  const res: JSX.Element[] = [];

  if (data.length === endDate.diff(startDate, 'day')) {
    const dataDateArray = mapScheduleDateData(startDate, endDate, data);
    data.forEach((item, index) => {
      const dateData = dataDateArray[index];
      res.push(
        <RowTimelineSchedule
          data={item}
          dateData={dateData}
          key={item[0] ? `${item[0].disciplName}${item[0].key}` : index}
        />,
      );
    });
  }

  return res;
};
